class LinkCache {
    constructor() {
        this.cache = {}
    }

    get(url) {
        return this.cache[url]
    }

    set(url, data) {
        this.cache[url] = data
    }

    has(url) {
        return url in this.cache
    }

    remove(url) {
        delete this.cache[url]
    }

    clear() {
        this.cache = {}
    }
}

export default new LinkCache()